/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserRequestDto = {
    /**
     * ID пользователя в Keycloak
     */
    keycloakUserId: string;
    /**
     * Фамилия
     */
    lastname: string;
    /**
     * Имя
     */
    firstname: string;
    /**
     * Отчество
     */
    middleName?: string;
    /**
     * Название компании
     */
    company: string;
    /**
     * ИНН компании
     */
    innCompany?: string;
    /**
     * Почта
     */
    email: string;
    /**
     * Статус
     */
    status?: UserRequestDto.status;
    /**
     * Комментарий
     */
    comment?: string;
    /**
     * Мобильный телефон
     */
    mobilePhone?: string;
};

export namespace UserRequestDto {

    /**
     * Статус
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        SUSPENDED = 'SUSPENDED',
        PENDING = 'PENDING',
    }


}

